/**
 * Shell for logged-out visitors opening shared post or profile links.
 * Log in / sign up live in route content, not in a global header.
 */

import React from 'react';

function ShareGuestChrome({ children }) {
  return (
    <div className="h-dvh flex flex-col bg-void overflow-hidden" data-testid="share-guest-chrome">
      <div className="flex-1 min-h-0 overflow-y-auto">{children}</div>
    </div>
  );
}

export default ShareGuestChrome;
